module.exports = __webpack_public_path__ + "media/svg/croix_cercle-57c03dda.svg";